import candidateProfilesReducer from './candidateProfiles'
import staticCountryReducer from './staticCountries'
import staticJobRoleReducer from './staticJobRoles'
import jobPreferenceReducer from './jobPreferences'
import talentAdvisorReducer from './talentAdvisors'
import codingTestReducer from './codingTests'

import * as candidateProfileEntities from './candidateProfiles'
import * as jobPreferenceEntities from './jobPreferences'
import * as talentAdvisorEntities from './talentAdvisors'
import * as codingTestEntities from './codingTests'

export default {
  candidateProfiles: candidateProfilesReducer,
  staticCountries: staticCountryReducer,
  staticJobRoles: staticJobRoleReducer,
  jobPreferences: jobPreferenceReducer,
  talentAdvisors: talentAdvisorReducer,
  codingTests: codingTestReducer,
}

export { candidateProfileEntities, jobPreferenceEntities, talentAdvisorEntities, codingTestEntities }
